// extracted by mini-css-extract-plugin
export default {"imgEmptyState":"style-module--imgEmptyState--oC0jp","buttonSearchAgain":"style-module--buttonSearchAgain--6UoA2"};